<template>
  <div class="teen-page teen4">
    <div class="header">
      <h1>万里长城：世界的奇迹</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_4.png" alt="长城日落">
        <div class="caption">万里长城，蜿蜒起伏，气势磅礴</div>
      </div>

      <h2>一、 长城的历史</h2>
      <p>长城是中国古代最伟大的军事防御工程。它始建于春秋战国时期，经过秦、汉、明等多个朝代的修建和扩建，形成了今天我们看到的规模。长城全长超过2万公里，是世界上最长的人工建筑。</p>

      <h2>二、 建造的智慧</h2>
      <p>长城的建造体现了古代中国人民的智慧和创造力。建筑材料就地取材，城墙由巨大的石块和砖块砌成，结构坚固。烽火台的设计更是精妙，能够快速传递军情。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_4.png" alt="长城烽火台">
        <div class="caption">长城烽火台，古代的信息传递站</div>
      </div>

      <h2>三、 重要关隘</h2>
      <p>长城沿线有许多重要的关隘，如山海关、居庸关、嘉峪关等。这些关隘是古代军事防御的重要据点，也是丝绸之路的重要通道。山海关被誉为"天下第一关"，是长城的东起点。</p>

      <h2>四、 长城的意义</h2>
      <p>长城不仅是军事防御工程，更是中华民族精神的象征。它代表着坚韧不拔、众志成城的精神。1987年，长城被联合国教科文组织列入世界文化遗产名录。</p>

      <div class="quote-box">
        "不到长城非好汉。" —— 毛泽东
      </div>

      <h2>五、 保护与传承</h2>
      <p>历经千年风雨，长城的许多段落已经损毁。保护长城是我们每个人的责任。近年来，政府和社会各界都在积极开展长城的保护和修复工作，让这份珍贵的文化遗产能够传承下去。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen4'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #f5f5f0;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #4a4a4a 0%, #6b6b6b 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #4a4a4a;
  border-bottom: 2px solid #888;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #e8e8e0;
  padding: 20px;
  border-left: 4px solid #4a4a4a;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>